/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableCustomisationDto,
  AccountsPayableCustomisationUpdateRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPaymentCustomisationsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name GetCustomisations
   * @request GET:/api/v1/customisations/accounts-payable
   */
  getCustomisations = (params: RequestParams = {}) =>
    this.http.request<AccountsPayableCustomisationDto[], any>({
      path: `/v1/customisations/accounts-payable`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCustomisationsPath = '/v1/customisations/accounts-payable'
  static getCustomisationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name UpdateCustomisation
   * @request PUT:/api/v1/customisations/accounts-payable
   */
  updateCustomisation = (
    data: AccountsPayableCustomisationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountsPayableCustomisationDto, any>({
      path: `/v1/customisations/accounts-payable`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCustomisationPath = '/v1/customisations/accounts-payable'
  static updateCustomisationMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name RequestDisableFourEye
   * @request POST:/api/v1/customisations/accounts-payable/request-disable-four-eye
   */
  requestDisableFourEye = (params: RequestParams = {}) =>
    this.http.request<AccountsPayableCustomisationDto, any>({
      path: `/v1/customisations/accounts-payable/request-disable-four-eye`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static requestDisableFourEyePath = '/v1/customisations/accounts-payable/request-disable-four-eye'
  static requestDisableFourEyeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name RejectFourEyeDisableRequest
   * @request POST:/api/v1/customisations/accounts-payable/reject-disable-four-eye-request
   */
  rejectFourEyeDisableRequest = (params: RequestParams = {}) =>
    this.http.request<AccountsPayableCustomisationDto, any>({
      path: `/v1/customisations/accounts-payable/reject-disable-four-eye-request`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static rejectFourEyeDisableRequestPath =
    '/v1/customisations/accounts-payable/reject-disable-four-eye-request'
  static rejectFourEyeDisableRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name ConfirmFourEyeDisableRequest
   * @request POST:/api/v1/customisations/accounts-payable/confirm-disable-four-eye-request
   */
  confirmFourEyeDisableRequest = (params: RequestParams = {}) =>
    this.http.request<AccountsPayableCustomisationDto, any>({
      path: `/v1/customisations/accounts-payable/confirm-disable-four-eye-request`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static confirmFourEyeDisableRequestPath =
    '/v1/customisations/accounts-payable/confirm-disable-four-eye-request'
  static confirmFourEyeDisableRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-payment-customisations-controller
   * @name CancelFourEyeDisableRequest
   * @request POST:/api/v1/customisations/accounts-payable/cancel-disable-four-eye-request
   */
  cancelFourEyeDisableRequest = (params: RequestParams = {}) =>
    this.http.request<AccountsPayableCustomisationDto, any>({
      path: `/v1/customisations/accounts-payable/cancel-disable-four-eye-request`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static cancelFourEyeDisableRequestPath =
    '/v1/customisations/accounts-payable/cancel-disable-four-eye-request'
  static cancelFourEyeDisableRequestMethod = 'POST'
}
